import { api } from '@/lib/api';

export const doctorsService = {
  async getAll() {
    const { data } = await api.get('/doctors');
    return { data };
  },

  async getMine() {
    const { data } = await api.get('/doctors/me');
    return { data };
  },

  async getAvailableSlots(doctorId, date) {
    const { data } = await api.get('/doctors/slots/available', {
      params: { doctorId, date },
    });
    return { data };
  },

  async create(payload) {
    const { data } = await api.post('/doctors', payload);
    return { data };
  },
};
